export default "__VITE_ASSET__gAOcscRY__"